import useEvent from "react-use-event-hook";
import { useSetRecoilState } from "recoil";

import {
  RydeUiUnit,
  selectedTableRowsIdsAtomFamily,
  stationsMapSelectedIdsAtom,
} from "@ryde/shared";

const STATION_ENTITY: RydeUiUnit = "station";

/**
 * The stations bulk selection has two independent sources — grid checkboxes and map markers — and
 * `stationsBulkTargetRowsSelector` reads whichever one the bulk-target panel points at, so a bulk action
 * that consumed stations has to drop them from both.
 */
export const useStationsBulkSelection = () => {
  const setGridSelectedIds = useSetRecoilState(
    selectedTableRowsIdsAtomFamily(STATION_ENTITY),
  );
  const setMapSelectedIds = useSetRecoilState(stationsMapSelectedIdsAtom);

  /** Drops only the stations the action ran on; anything else the user picked stays selected. */
  const removeStationsBulkSelectedIds = useEvent(
    (stationIds: number[]): void => {
      if (!stationIds?.length) {
        return;
      }

      const idsToRemove = new Set(stationIds);
      const withoutRemovedIds = (ids: number[]): number[] =>
        ids.filter(id => !idsToRemove.has(id));

      setGridSelectedIds(withoutRemovedIds);
      setMapSelectedIds(withoutRemovedIds);
    },
  );

  return { removeStationsBulkSelectedIds };
};
